<!-- 交付在线 - 首页 lzj -->
<template>
    <div class="content">
        <div :class="['header_back']">
            <div class="back_icon" @click.stop="goback">
                <span></span>
            </div>
            {{ $route.meta.title }}
        </div>
        <div v-if="objState == 0 || objState == 1 || nForbid != 0" class="default_wrap">
            <!--            <div v-if="true" class="default_wrap">-->
            <img src="~@/assets/images/user/housev2/default_img.png" alt="">
            <h1>暂未查询到您的项目交付档案</h1>
            <!-- <template v-if="nForbid == 0">-->
            <template>
                <p>项目交付档案主要针对购买A.O.史密斯智慧集成系统且<br/>施工时间在2022年1月10日后的项目。请使用<br/>购买A.O.史密斯该系统预留的手机号码进入查询。</p>
            </template>
        </div>
        <template v-else-if="progress.length">
            <div v-if="objState > 1" class="index_wrap">
                <div class="user_info">
                    <!-- <img class="head" v-lazy="userInfo.headimgurl" alt="">-->
                    <img class="head" src="~@/assets/images/user/housev2/head_dome.png" alt="">
                    <div class="info">
                        <p class="name omit-s">{{ objAccount.name }}</p>
                        <p class="phone">{{ objAccount.new_telephone }}</p>
                    </div>
                    <div :class="{'msg_box':true, 'red_dot':nMsgNum > 0}" :data-num="nMsgNum > 99 ? '99+' : nMsgNum"
                         @click="myNews">
                        <img class="msg_icon" src="~@/assets/images/user/housev2/msg_icon.png" alt=""/>
                        <p class="msg_text">消息</p>
                    </div>
                </div>
                <div class="plan_info">
                    <div v-if="objState == 2" class="plan_state">未进场</div>
                    <div v-if="objState == 3" class="plan_state">施工中</div>
                    <div v-if="objState == 4" class="plan_state">已完工</div>
                    <div class="plan_name omit-s">
                        {{
                            userPactState ? objAccount.new_name : objAccount.new_city_idname + objAccount.new_county_idname
                                + objAccount.new_address
                        }}
                    </div>
                    <div class="plan_lable">
                        <p>{{ objAccount.new_area ? objAccount.new_area + ' m²' : '不详' }}</p>
                        <p>
                            {{ objAccount.new_roomnumber ? objAccount.new_roomnumber + '室' : '' }}{{
                                objAccount.new_hall ? objAccount.new_hall + '厅' : ''
                            }}{{ objAccount.new_toilet ? objAccount.new_toilet + '卫' : '' }}{{
                                objAccount.new_kitchen ? objAccount.new_kitchen + '厨' : ''
                            }}
                        </p>
                        <p>{{ objAccount.new_housetype_name ? objAccount.new_housetype_name : '不详' }}</p>
                    </div>
                    <div class="more_plan" @click="myProject" v-if="!isShowShare">
                        <p>切换项目<img class="arrw_icon" src="~@/assets/images/user/housev2/arrw_icon.png" alt=""/></p>
                        <p>全部 {{ nProject > 9 ? '9+' : nProject }} 项</p>
                    </div>
                </div>
                <div class="schedule_box">
<!--                    <div class="schedule_top">-->
<!--                        <p>进度</p>-->
<!--                        <p @click="goSchedule">-->
<!--                            全部进度-->
<!--                            <img class="arrw_icon" src="~@/assets/images/user/housev2/arrw_icon.png" alt=""/>-->
<!--                        </p>-->
<!--                    </div>-->
                    <div class="schedule_menu">
                        <div v-for="(item,index) in arrScheduleMennu" :key="index" @click="touchMenu(index)"
                             :class="{'schedule_item':true,'schedule_item_select':nScheduleMennuIndex == index}">
                            <img v-if="nScheduleMennuIndex == index" :src="item.img" alt="">
                            <img v-else :src="item.img_no" alt="">
                            <!-- <p>{{ item.text }}</p>-->
                            <div :class="{'slip':true,'slip_select':nScheduleMennuIndex == index}"></div>
                        </div>
                    </div>
                    <!--  <div v-show="nScheduleMennuIndex == 2 && objProject.is_completed == '1' && arrUnfoldMenu[6].light"-->
                    <div v-if="false" class="accept_top" @click="meunClick(6)">
                        查看项目交付报告
                        <img src="~@/assets/images/user/housev2/arrw_icon2.png" alt="">
                    </div>
                </div>
                <div :class="{'schedule_list':true,'schedule_list2':isShowShare,'schedule_list_not':showLog.list.length == 0}">
<!--                    <div  v-show="nScheduleMennuIndex == 2 && arrUnfoldMenu[4].light && objProject.is_build_completed == '1' && objProject.is_completed == '1'"-->
<!--                        :class="{'accept_box':true,'accept_box2':(is_evaluate && is_evaluate != 0)}">-->
<!--                        <div class="accept_time">-->
<!--                            <div class="dot blue_dot"></div>-->
<!--                            <p>时间 </p>-->
<!--                            <p>{{ objProject.completed_date }} 更新</p>-->
<!--                        </div>-->
<!--                        <div class="accept_msg">-->
<!--                            <p>{{ '智慧集成系统施工已全部完工并验收完毕，请进行最终竣工验收' }}</p>-->
<!--                            <div :class="{'accept_btn':true,'accept_btn2':(is_evaluate && is_evaluate != 0)}"-->
<!--                                 @click="touchAccept">-->
<!--                                {{ (is_evaluate && is_evaluate != 0) ? '已验收' : '验收' }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-show="nScheduleMennuIndex != 3" class="team_info">-->
<!--                        <template v-if="!(objMainShow&&objMainShow.id)">-->
<!--                            <div class="member_info">-->
<!--                                <img class="member_head" src="~@/assets/images/user/housev2/head_default.png" alt="">-->
<!--                                <div>-->
<!--                                    <div class="member_number member_number_not">-->
<!--                                        <p>待指派</p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                        <template v-else>-->
<!--                            <div class="member_info">-->
<!--                                <img class="member_head" v-lazy="objMainShow.icon" alt="">-->
<!--                                <div>-->
<!--                                    <div class="member_number">-->
<!--                                        <p>{{ objMainShow.rel_group_name }}</p>-->
<!--                                        <p v-if="objMainShow.job_number">工牌：{{ objMainShow.job_number }}</p>-->
<!--                                    </div>-->
<!--                                    <p class="member_name">{{ objMainShow.name }}</p>-->
<!--                                    <div v-if="false" class="member_reate">-->
<!--                                        <van-rate v-model="reate" :size="16" allow-half readonly color="#FCBF82"-->
<!--                                                  void-icon="star" void-color="#eee"/>-->
<!--                                        <p style="font-size: 12px;line-height: 12px;">{{ reate }} 分</p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <img v-if="objMainShow.qr_code != ''"-->
<!--                                     @click.stop="showQrcodePopup(objMainShow.name,objMainShow.qr_code)"-->
<!--                                     class="phone_icon" src="~@/assets/images/user/housev2/qrcode_icon.png" alt="">-->
<!--                            </div>-->
<!--                        </template>-->
<!--                        <template v-if="!objThemInfo.team || (objThemInfo.team && objThemInfo.team.length <= 0)">-->
<!--                            <div class="team_list">-->
<!--                                <div class="team_item">项目团队：待指派</div>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                        <template v-else>-->
<!--                            <div class="team_list">-->
<!--                                <div class="team_item">项目团队：-->
<!--                                    <img v-for="(item,index) in objThemInfo.team" v-lazy="item.icon" alt="">-->
<!--                                </div>-->
<!--                                <div class="team_look" @click="meunClick(5)">-->
<!--                                    查看-->
<!--                                    <img src="~@/assets/images/user/housev2/arrw_icon2.png" alt="">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </div>-->
<!--                    <template-->
<!--                        v-if="(nScheduleMennuIndex != 3 && showLog.list.length == 0 )|| (nScheduleMennuIndex == 3 && objProject.is_completed != '1')">-->
<!--                        <div class="default_box">-->
<!--                            <img src="~@/assets/images/user/housev2/default_img2.png" alt="">-->
<!--                            <p>暂无信息</p>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                    <template v-else-if="nScheduleMennuIndex != 3">-->
<!--                        <div class="schedule_info">-->
<!--                            <div class="schedule_title green">-->
<!--                                <p>{{ showLog.title }}</p>-->
<!--                            </div>-->
<!--                            <div v-for="(item,index) in showLog.list" :key="index" class="schedule_info_item">-->
<!--                                <div class="schedule_time">-->
<!--                                    <div class="dot green_dot"></div>-->
<!--                                    <p>时间</p>-->
<!--                                    <p>{{ handleTime(item.time) }} 更新</p>-->
<!--                                    <template v-if="item.qr_code != ''">-->
<!--                                        <img @click.stop="showQrcodePopup(item.name,item.qr_code)" class="phone_icon"-->
<!--                                             src="~@/assets/images/user/housev2/qrcode_icon.png" alt="">-->
<!--                                    </template>-->
<!--                                </div>-->
<!--                                <div class="schedule_msg">-->
<!--                                    <div class="msg">-->
<!--                                        <p class="text">{{ item.text }}</p>-->
<!--                                        <template-->
<!--                                            v-if="(item.url && item.url != '' &&  nScheduleMennuIndex == 0  && arrUnfoldMenu[3].light)  || (nScheduleMennuIndex == 1  && arrUnfoldMenu[2].light)  || (nScheduleMennuIndex == 2  && arrUnfoldMenu[4].light && item.process && item.process > 0) ">-->
<!--                                            <img @click="touchLook(nScheduleMennuIndex,item)" class="look_icon"-->
<!--                                                 src="~@/assets/images/user/housev2/look_icon.png" alt=""/>-->
<!--                                        </template>-->
<!--                                    </div>-->
<!--                                    <div v-if="item.memo && item.memo != ''" class="hint_box">-->
<!--                                        <p class="hint">变更描述：</p>-->
<!--                                        <p class="hint">{{ item.memo }}</p>-->
<!--                                    </div>-->
<!--                                    <div v-if="item.image && item.image.length > 0" class="img_box">-->
<!--                                        <img v-for="(item2,index2) in item.image" :key="item.annotationid"-->
<!--                                             :src="item2.new_filepath" @click="touchLookImg(item.image,index2)" alt="">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                    <template v-else-if="nScheduleMennuIndex == 3 && objProject.is_completed == '1'">-->
<!--                        <div class="report_box" @click="meunClick(4)">-->
<!--                            <div class="msg">隐蔽系统施工</div>-->
<!--                            <div class="msg msg2">交付报告</div>-->
<!--                            <div class="btn">立即查看</div>-->
<!--                        </div>-->
<!--                    </template>-->
                    <!-- 3.0版本-->
                    <div class="schedule-box"  v-show="nScheduleMennuIndex == 0">
                        <div class="schedule-title">
                            <img src="@/assets/images/project/100.png" alt="">
                            <span class="text01">施工进度</span>
                            <!--                            <span class="text02" v-if="isShowShare">{{nBuildDay}}</span>-->
                        </div>
                        <div class="schedule-content">
                            <template v-for="item in arrSchedule">
                                <div class="item" :class="{'item-active':nCurrentSchedule>=item.id,'item-active-two':nCurrentSchedule>item.id}">
                                    <div class="yuan" :class="{'yuan-active':nCurrentSchedule>=item.id}">
                                        <span></span>
                                    </div>
                                    <span>{{item.name}}</span>
                                </div>
                            </template>
                        </div>
                        <div class="team-wrap">
                            <div class="team-left">
                                <span>项目团队：</span>
                                <div class="head-wrap">
                                    <template v-for="(item,index) in objThemInfo.team">
                                        <div class="head-item">
                                            <img v-lazy="item.icon" alt="">
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="team-right"  @click="meunClick(5)">
                                <span>查看</span>
                                <img src="@/assets/images/project/down_icon1.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="schedule-box-list" v-show="nScheduleMennuIndex == 0">
                        <div class="schedule_info" v-for="item in arrScheduleAllInfo">
                            <!--标题-->
                            <div class="schedule_title" :class="{'schedule_title-design':item.type=='third_img','schedule_title-contract':item.type=='contract_draft','schedule_title-project':item.type=='process_detail'}">
                                <p>
                                    <span>{{ item.title }}</span>
                                    <span class="state" v-if="(item.type=='third_img' && arrUnfoldMenu[3].light) || (item.type=='contract_draft' && arrUnfoldMenu[2].light) ||  (item.type=='process_detail' && objProject.is_build_completed == '1')">
                                        <img src="@/assets/images/project/Tick-icon.png" alt="">
                                        <span>已交付</span>
                                    </span>
                                </p>
                            </div>
                            <!-- 团队-->
                            <div  class="team_info">
                                <template v-if="!(item.team&&item.team.id)">
                                    <div class="member_info">
                                        <img class="member_head" src="~@/assets/images/user/housev2/head_default.png" alt="">
                                        <div>
                                            <div class="member_number member_number_not">
                                                <p>待指派</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="member_info">
                                        <img class="member_head" v-lazy="item.team.icon" alt="">
                                        <div>
                                            <div class="member_number">
                                                <p>{{ item.team.rel_group_name }}</p>
                                                <p v-if="item.team.job_number">工牌：{{ item.team.job_number }}</p>
                                            </div>
                                            <p class="member_name">{{ item.team.name }}</p>
                                            <div v-if="true" class="member_reate">
                                                <van-rate v-model="reate" :size="16" allow-half readonly color="#FCBF82"
                                                          void-icon="star" void-color="#eee"/>
                                                <p style="font-size: 12px;line-height: 12px;">{{ reate }} 分</p>
                                            </div>
                                        </div>
                                        <img v-if="item.team.qr_code != ''"
                                             @click.stop="showQrcodePopup(item.team.name,item.team.qr_code)"
                                             class="phone_icon"
                                             src="~@/assets/images/user/housev2/qrcode_icon.png" alt="">
                                    </div>
                                </template>
                                <template v-if="!objThemInfo.team || (objThemInfo.team && objThemInfo.team.length <= 0)">
                                    <div class="team_list">
                                        <div class="team_item">项目团队：待指派</div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="team_list">
                                        <div class="team_item">项目团队：
                                            <img v-for="(item,index) in objThemInfo.team" v-lazy="item.icon" alt="">
                                        </div>
                                        <div class="team_look" @click="meunClick(5)">
                                            查看
                                            <img src="~@/assets/images/user/housev2/arrw_icon2.png" alt="">
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <!-- 进度-->
                            <div v-for="(it,itx) in item.list" :key="itx" class="schedule_info_item">
                                <div class="schedule_time">
                                    <div class="dot green_dot"></div>
                                    <p>{{item.title=='合同'?'合同备忘':item.title=='设计方案'?'方案设计':it.title}}</p>
                                    <p>{{it.time?it.time.replaceAll('-','.'):''}}</p>
                                    <template v-if="it.qr_code != ''">
                                        <img @click.stop="showQrcodePopup(it.name,it.qr_code)"
                                             class="phone_icon"
                                             src="~@/assets/images/user/housev2/qrcode_icon.png" alt="">
                                    </template>
                                </div>
                                <div class="schedule_msg">
                                    <div class="msg">
                                        <p class="text">{{ it.text }}</p>
                                        <template
                                            v-if="nScheduleMennuIndex == 0 && ((arrUnfoldMenu[3].light && it.url && it.url != '' && item.type=='third_img') ||  (arrUnfoldMenu[2].light &&  item.type=='contract_draft') || (arrUnfoldMenu[4].light && it.process && it.process > 0 &&  item.type=='process_detail') ) ">
                                            <img @click="touchLook(item,it)" class="look_icon"
                                                 src="~@/assets/images/user/housev2/look_icon.png" alt=""/>
                                        </template>
                                    </div>
                                    <div v-if="it.memo && it.memo != ''" class="hint_box">
                                        <p class="hint">变更描述：</p>
                                        <p class="hint">{{ it.memo }}</p>
                                    </div>
                                    <div v-if="it.image && it.image.length > 0" class="img_box">
                                        <img v-for="(item2,index2) in it.image" :key="it.annotationid"
                                             :src="item2.new_filepath" @click="touchLookImg(it.image,index2)" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="common-info" v-show="nScheduleMennuIndex == 1">
                        <div class="common-item"  @click="meunClick(1)" v-if="arrUnfoldMenu[1].light">
                            <div class="common-title">
                                <div class="left">方案书</div>
                                <div class="right">
                                    <img src="@/assets/images/project/Tick-icon.png" alt="" v-if="arrUnfoldMenu[1].light">
                                    <img src="@/assets/images/project/Tick-icon_n.png" alt="" v-if="!arrUnfoldMenu[1].light">
                                    <span>{{arrUnfoldMenu[1].light?'已交付':'未交付'}}</span>
                                </div>
                            </div>
                            <div class="common-content">
                                <span class="text1">专属定制方案书</span>
                                <span class="text2">Exclusive Customization Proposal</span>
                                <img src="@/assets/images/project/fan.png" alt="">
                            </div>
                        </div>
                        <div class="common-item"  @click="meunClick(2)">
                            <div class="common-title">
                                <div class="left">设备清单</div>
                                <div class="right">
                                    <img src="@/assets/images/project/Tick-icon.png" alt="" v-if="arrUnfoldMenu[2].light">
                                    <img src="@/assets/images/project/Tick-icon_n.png" alt="" v-if="!arrUnfoldMenu[2].light">
                                    <span>{{arrUnfoldMenu[2].light?'已交付':'未交付'}}</span>
                                </div>
                            </div>
                            <div class="contract-content contract-content-sb">
                                <div class="auto-wrap">
                                    <template v-for="item in arrImgContracyid">
                                        <div class="img-item">
                                            <img v-lazy="item.img" alt="">
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="common-item" v-if="arrUnfoldMenu[3].light" @click="meunClick(3)">
                            <div class="common-title">
                                <div class="left">三维设计</div>
                            </div>
                            <div class="d3-content">
                                <img src="@/assets/images/project/3d-img.png" alt="">
                            </div>
                        </div>
                        <div class="common-item d3-content-vr-item" v-if="arrUnfoldMenu[8].light">
                            <div class="common-title">
                                <div class="left">隐蔽系统VR</div>
                                <div class="right">
                                    <img src="@/assets/images/project/Tick-icon.png" alt="" v-if="arrUnfoldMenu[8].light">
                                    <img src="@/assets/images/project/Tick-icon_n.png" alt="" v-if="!arrUnfoldMenu[8].light">
                                    <span>{{arrUnfoldMenu[8].light?'已交付':'未交付'}}</span>
                                </div>
                            </div>
                            <div class="d3-content d3-content-vr" :class="{'iframe-vr-completed':vrFixedType===0}">
                                <span @click.stop="vrFixedType=null" v-if="vrFixedType!=null">退出</span>
                                <iframe :src="arrUnfoldMenu[8].id" frameborder="0"></iframe>
                            </div>
                            <div class="mask"  @click="vrFixed(0)" ></div>
                        </div>
                        <div class="common-item d3-content-vr-item" v-if="arrUnfoldMenu[9].light">
                            <div class="common-title">
                                <div class="left">竣工VR</div>
                                <div class="right">
                                    <img src="@/assets/images/project/Tick-icon.png" alt="" v-if="arrUnfoldMenu[9].light">
                                    <img src="@/assets/images/project/Tick-icon_n.png" alt="" v-if="!arrUnfoldMenu[9].light">
                                    <span>{{arrUnfoldMenu[9].light?'已交付':'未交付'}}</span>
                                </div>
                            </div>
                            <div class="d3-content d3-content-vr" :class="{'iframe-vr-completed':vrFixedType===1}">
                                <span @click.t.stop="vrFixedType=null" v-if="vrFixedType!=null">退出</span>
                                <iframe :src="arrUnfoldMenu[9].id" frameborder="0"></iframe>
                            </div>
                            <div class="mask" @click="vrFixed(1)"></div>
                        </div>
                        <div class="common-item common-item-standard" @click="toStandard" v-if="false">
                            <div class="common-title standard-title">
                                <div class="left">施工标准</div>
                                <div class="right">
                                    <img src="@/assets/images/project/down_icon1.png" alt="">
                                </div>
                                <img class="bz-icon" src="@/assets/images/project/famb.png" alt="">
                            </div>
                        </div>
                        <template v-for="item in arrProjectList">
                            <div class="common-item" @click="toReportDetail(item)">
                                <div class="common-title report-title">
                                    <div class="left" :class="{'left-color':item.fin_status_txt!='已交付'}">{{item.title}}</div>
                                    <div class="right">
                                        <img v-if="item.fin_status_txt=='已交付'" src="@/assets/images/project/Tick-icon.png" alt="" />
                                        <img v-else src="@/assets/images/project/Tick-icon_n.png" alt="" />
                                        <span>{{item.fin_status_txt}}</span>
                                    </div>
                                </div>
                                <div class="contract-content">
                                    <div class="img-l">
                                        <template v-for="(it,itx) in item.attach">
                                            <div class="img-item" v-if="itx<4">
                                                <img v-lazy="it" alt="">
                                            </div>
                                        </template>
                                    </div>
                                    <div class="img-r" v-if="item.fin_status_txt=='已交付'">
                                        <img src="@/assets/images/processv2/dsvgx.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="default_box" v-show="nScheduleMennuIndex == 2 || nScheduleMennuIndex == 3">
                        <img src="~@/assets/images/user/housev2/default_img2.png" alt="">
                        <p>敬请期待</p>
                    </div>
                </div>
                <div :class="{'bottom_menu':true, 'bottom_menu2':isShowShare}">
                    <div v-if="false" :class="{'unfold_not':true, 'unfold':isUnfoldMenu}">
                        <div v-show="isUnfoldMenu" class="unfold_box">
                            <div class="unfold_items">
                                <template v-for="(item,index) in arrUnfoldMenu">
                                    <div v-if="(item.type_key != 'contact' && item.isShow) && item.light"
                                         :class="{'unfold_item_not':true ,'unfold_item':item.light, 'red_dot': false}"
                                         :data-num="item.num  > 9 ? '9+' : item.num " :key="index">
                                        <!--  :class="{'unfold_item_not':true ,'unfold_item':item.light, 'red_dot':item.num > 1 && item.light}"-->
                                        <img :src="item.img" alt="" @click="meunClick(index)">
                                    </div>
                                </template>
                                <div class="unfold_item_not"></div>
                            </div>
                            <div class="unfold_btn" @click="touchUnfold">
                                <img src="~@/assets/images/user/housev2/arrw_icon.png" alt="">
                            </div>
                        </div>
                        <div v-show="!isUnfoldMenu" class="unfold_not_box" @click="touchUnfold">
                            <p>项目<br/> 资料库</p>
                            <img src="~@/assets/images/user/housev2/arrw_icon.png" alt="">
                        </div>
                    </div>
                    <!-- <div v-if="arrUnfoldMenu[7].isShow" :class="{'fixed_box':true,'fixed_box_not': !arrUnfoldMenu[7].light} " @click="meunClick(7)"> -->
                    <!--施工完成后显示-->
                    <div v-if="arrUnfoldMenu[7].isShow && objProject.is_build_completed == '1'" class="fixed_box"
                         @click="meunClick(7)">
                        <img src="~@/assets/images/user/housev2/mail_icon.png" alt="">
                        <!-- <p>总裁<br/>直通车</p> -->
                        <p>我要<br/>评价</p>
                    </div>
                </div>
                <div v-if="mokanSingleUrl"  @click="touchMokan" :class="{'bottom_menu':true,'bottom_menu_gd':true,'bottom_menu2':isShowShare}">
                    <!--施工完成后显示-->
                    <div class="fixed_box">
                        <p>工地<br/>在线</p>
                        <img src="~@/assets/images/project/video-zaixain.png" alt="">
                    </div>
                </div>
            </div>
        </template>
        <!--   鉴权潜客   -->
        <el-authority @changeLogin="changeLogin"></el-authority>

        <!--nEwmImg-->
        <qrcodePopup :nPopup.sync="isQrcodePopup" :nEwmImg="sQcCodeImg" :nTitle="sQrcodeName"
                     @changeTag="showQrcodePopup"></qrcodePopup>
        <lookPopup :show="isLookPopup" :type="lookPopup.type" :btn-text="lookPopup.btnText" :msg="lookPopup.msg"
                   :url="lookPopup.url" @close="showLookpopup"></lookPopup>
        <share ref="myShare" v-if="isShowShare" :isHouse="false" :title="objAccount.new_name" :isFixed="true"></share>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import elAuthority from "@/components/hvac/authority/index.vue";
import {getProjectList} from "@/js/map.js";
import {getUser} from "@/js/user/user.js";
import {getNotify, getChange} from "@/js/member/mynews/index.js";
import {getProjectLog, getTeamV2, getProectList, getList, clearAppPost} from "@/js/house/appindex.js";
import {getWxSingleConfig, wxGetLocationH5, geoGetLocation} from "@/js/wx.js";
import {getRandomString} from "@/utils/stringUtils.js"
import qrcodePopup from '../components/qrcode.vue';
import lookPopup from '../components/look.vue';
import share from '../components/share.vue';
import {getReportShare} from "@/js/member/mynews/index.js";
import {ImagePreview} from 'vant';
import {createLog, getMokan} from "@/js/house";
import { hex_md5 } from "@/libs/md5";
import oStorage from '@/libsV2/storage.js';
import oDeliver from "@/js/deliver";
import { memberlistV2 , getMemorandumInfo} from '@/js/house/appindex.js';
//
export default {
    name: 'MemberIndex_useKP',
    components: {
        Swiper,
        SwiperSlide,
        elAuthority,
        qrcodePopup,
        lookPopup,
        share
    },
    data() {
        return {
            mokanSingleUrl: '',//魔看直播链接
            arrProjectList:[],//项目报告列表
            vrFixedType:null,
            arrImgContracyid:[],//合同产品设备
            arrScheduleAllInfo:[],//项目日志,合同,3d设计进度数据
            nCurrentSchedule:-10,
            arrSchedule:[],//项目日志施工情况
            nForbid: 0,
            isShowShare: false,//是否显示分享
            abnormal: true, //是否绑定
            progress: [], // 设计进度
            userPactState: false, // 合同状态
            swiperOption: {
                loop: false, // 循环回路
                slidesPerView: "auto", // 设置slider容器能够同时显示的slides数量; 设置为auto则自动根据slides的宽度来设定数量
                centeredSlides: false, // 设定为true时，active slide会居中，而不是默认状态下的居左
                spaceBetween: 12, // 每个swiper-slide之间的间隔
            },
            objAccount: {}, // 用户信息
            arrbtn: [
                // 用户切换
            ],
            nProject: 0,// 用户项目数量 todo 可合并到objProject中，需要接口配合
            objProject: {}, // 用户项目
            arrMessage: [
                {data: {detail_msg: '', finish_time: ''}}
            ],
            // 我的消息
            nMsgNum: 0, //消息的未读数量
            // nMsgTotalNum: 0, //消息的总数量
            arrMessageList: [{data: {detail_msg: '', finish_time: ''}}],
            arrImg: [], // 业主口碑
            objState: null, // 合同状态

            imgUrl: {}, // 图片
            imgIndex: 0,
            lookImgIndex: 0,
            images: [],
            nContractId: 0, //合同id
            arrCaseList: [], //项目案例列表

            nScheduleMennuIndex: 0,
            arrScheduleMennu: [{
                img: require('/src/assets/images/project/tab/rz-a.png'),
                img_no: require('/src/assets/images/project/tab/rz-n.png'),
                text: '项目日志'
            }, {
                img: require('/src/assets/images/project/tab/zl-a.png'),
                img_no: require('/src/assets/images/project/tab/zl-n.png'),
                text: '项目档案'
            }, {
                img: require('/src/assets/images/user/housev2/tab_item3.png'),
                img_no: require('/src/assets/images/project/tab/js-build.png'),
                text: '施工在线'
            }, {
                img: require('/src/assets/images/user/housev2/tab_item4.png'),
                img_no: require('/src/assets/images/project/tab/js-build.png'),
                text: '无忧售后'
            }],
            isUnfoldMenu: false,//是否展开菜单
            arrUnfoldMenu: [{
                isShow: false,
                id: '',
                type_key: 'mapping', //勘察报告
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/unfold_item1.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'plan',//项目方案书
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/unfold_item2.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'contract_draft',//合同备忘
                num: 1,
                light: false,
                img: require('/src/assets/images/user/housev2/unfold_item3.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'third_img',//3D设计方案
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/unfold_item4.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'process_detail',//施工报告
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/unfold_item5.png'),
            }, {
                isShow: false,
                id: '',
                type_key: 'project_group',//项目团队
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/unfold_item6.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'score',//竣工验收
                num: 0,
                light: false,
                img: require('/src/assets/images/user/housev2/unfold_item7.png'),
            }, {
                isShow: true,
                id: '',
                type_key: 'contact',//总裁直通车 -- 我要评价
                num: 0,
                light: false,
            },{
                    isShow: true,
                    id: '',
                    type_key: 'build_vr',//隐蔽系统VR
                    num: 0,
                    light: false,
                },{
                    isShow: true,
                    id: '',
                    type_key: 'supervisor_vr',//竣工Vr
                    num: 0,
                    light: false,
                }],

            isQrcodePopup: false,//是否显示二维码弹框
            sQcCodeImg: '',//企业微信的二维码
            sQrcodeName: '',//企业微信的名字
            isLookPopup: false,//是否显示查看弹框
            lookPopup: {
                type: 0,
                msg: '',
                btnText: '',
                url: '',
            },
            showLog: {
                title: '',
                list: [],
            }, //显示的日志
            designLog: [], //设计方案日志
            contractLog: [], //签订合同日志
            workLog: [], //施工在线日志
            objThemInfo: {},//团队信息
            objMainShow: {},//主要展示的员工信息
            isUpdata: false,//页面缓存后是否筛选
            reate: 5,//默认5星
            is_evaluate: 0,//0 - 为评价
            objSampleData:{},
        };
    },
    created() {
        this.objSampleData = this.$route.query;
        this.pageInit();
    },
    beforeRouteLeave(to, from , next){
        this.clearLogTimer()
        next()
    },
    watch: {
        $router(to, from) {
            console.log(to.path, form)
        }
    },
    beforeDestroy() {
        this.clearLogTimer();
    },
    activated() {
        if (this.isUpdata) {
            this.isUpdata = false;
            this.pageInit();
        } else {
            if (this.$userHouse.state.usreAppHouserList && this.$userHouse.state.usreAppHouserList.project) {
                this.createLogFun('PV');
            }
        }
        this.setLogTimer();
    },
    deactivated(e) {
        this.clearLogTimer();
    },
    methods: {
        goback() {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
            let isIos = !!u.match(/\(i[^;]+;(U;)? CPU.+Mac OS X/);
            this.clearLogTimer();
            if (isAndroid) {
                callNative.close();
            }
            if (isIos) {
                window.webkit.messageHandlers.callNative.postMessage("close");
            }
        },
        pageInit() {
            this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
            // this.getUserInfo(),
            this.getBound();
            // this.getUserNotify(),
        },
        touchMokan() {
            if (this.mokanSingleUrl) {
                window.open(this.mokanSingleUrl, '_blank')
            }
        },
        getMokanFun() {
            if (this.objProject.new_srv_projectmgnid) {
                getMokan({
                    project_uuid: this.objProject.new_srv_projectmgnid,
                }).then((res) => {
                    this.mokanSingleUrl = res.data.data.result.single_url;
                    console.log(this.mokanSingleUrl, 'single_url')
                })
            }
        },
        changeLogin(e) {
            that.getUserHouse();
        },
        getUserNotify(e) {
            let _that = this;
            getNotify({page: 0, limit: 1, type: 0, app: 1}).then(res => {
                // let arr = res.data.data.result.list;
                // _that.arrMessageList = arr;
                console.log(res)
                this.nMsgTotalNum = res.data.data.result.total;

                console.log('nMsgTotalNum', this.nMsgTotalNum)
            })
        },
        getBound() {
            let that = this;
            // that.$oInitData.memberInfo({
            //     h5_user_id: that.$storage.getStorage("user_id"),
            // }).then((res) => {
            //     this.$store.commit("loadSkeleton", { bool: true }); // 页面loading开启
            that.getUserHouse();
            // }).catch((error) => {
            //     this.abnormal = false;
            // });
        },
        // 绑定成功调用接口
        getUserHouse() {
            let objData = this.$storage.getStorage('sampleroom_info');
            let data = {
                source: 'h5',
                sampleroom: objData.sampleroom || '',
                accountid: objData.accountid || '',
                contractid: objData.contractid || '',
                systemuserid: objData.systemuserid || '',
                mobile: this.$route.query.appmob || '',
            }
            this.$storage.setStorage('app_mob', this.$route.query.appmob);
            if (data.sampleroom == 2) {
                this.isShowShare = true;
            }
            Promise.all([this.$userHouse.dispatch("getAppHouser", data)]).then((res) => {
                this.$store.commit('editAppUserId',this.$userHouse.state.usreAppHouserList.user_id)
                this.$storage.setStorage('app_user_id', this.$userHouse.state.usreAppHouserList.user_id);
                this.getMeberLists(this.$userHouse.state.usreAppHouserList.project.new_srv_projectmgnid)//获取报告;列表
                this.getMemorandum(null)
                let arrPlan =this.$userHouse.state.usreAppHouserList.plan
                if(arrPlan && arrPlan.length){
                    this.arrSchedule=arrPlan.map((it,itx)=>{
                        it.id=itx
                        if(it.state==1){
                            this.nCurrentSchedule=itx
                        }
                        return it
                    })
                }
                this.objAccount = this.$userHouse.state.usreAppHouserList.account; // 用户信息

                //请求数据
                this.$store.dispatch("banner/getAppBanner", {
                    source: 'h5',
                    adment_id: 7,
                    user_id: this.$userHouse.state.usreAppHouserList.user_id
                })
                //v2新增 - 展示手机号
                this.objAccount.new_telephone2 = this.objAccount.new_telephone
                this.objAccount.new_telephone = this.objAccount.new_telephone.slice(0, 3) + '****' + this.objAccount.new_telephone.slice(-4);
                this.$storage.setStorage('new_house', this.objAccount.new_house);
                //v2新增 - 展示未读信息
                this.nMsgNum = this.$userHouse.state.usreAppHouserList.notify_num;
                // v2 屏蔽关闭项目
                console.log(this.$userHouse.state.usreAppHouserList.forbid, '===>')
                this.nForbid = this.$userHouse.state.usreAppHouserList.forbid;

                this.progress = this.$userHouse.state.usreAppHouserList.btn_cur; // 合同进度
                this.progress.forEach((item) => {
                    if (item.type_name == "合同签订") {
                        // 如果没有签订合同 ，头部只显示用户地址，签订了，显示用户地址加项目地址；
                        this.userPactState = item.type_id == 0 || item.type_id == "" ? false : true;
                    }
                    item.isdata = item.type_id == 0 || item.type_id == "" ? false : true;
                });
                this.createLogFun('PV');
                this.objProject = this.$userHouse.state.usreAppHouserList.project; // 用户项目
                this.$storage.setStorage('objProject', this.objProject); //日志统计需要项目信息
                this.$storage.setStorage('project_uuid', this.objProject.new_srv_projectmgnid);//项目id保存本地
                console.log('跳转9',this.$userHouse.state.usreAppHouserList.restrict)
                if (this.$userHouse.state.usreAppHouserList.restrict == 1) {
                    this.$storage.setStorage('objProjectEva', JSON.stringify({
                        company_id: this.objProject.new_id,
                        project_uuid: this.objProject.new_srv_projectmgnid,
                        contract_id: this.$userHouse.state.usreAppHouserList.contract.new_contractid,
                    }));
                    let objData = this.$route.query;
                    let data = {
                        sampleroom: objData.sampleroom || '',
                        accountid: objData.accountid || '',
                        contractid: objData.contractid || '',
                        systemuserid: objData.systemuserid || ''
                    }
                    console.log('跳转919',this.$userHouse.state.usreAppHouserList.restrict)
                    //禁止访问其他页面，只能访问用户点评部分
                    // window.location.href = `${window.location.origin}/member/v2/ievaluate/evaluate?is_build_completed=${this.objProject.is_build_completed}&is_completed=${this.objProject.is_completed}&remove=${this.$route.query.remove || 0}&restrict=${this.$userHouse.state.usreHouserList.restrict}`
                    window.location.replace(`${window.location.origin}/member/v3/ievaluate/evaluate?project_uuid=${this.objProject.new_srv_projectmgnid}&appmob=${this.$route.query.appmob}&is_build_completed=${this.objProject.is_build_completed}&sampleroom=${data.sampleroom}&is_completed=${this.objProject.is_completed}&systemuserid=${data.systemuserid}&contractid=${data.contractid}&restrict=${this.$userHouse.state.usreAppHouserList.restrict}`);
                    // window.location.replace(`${window.location.origin}/member/v3/ievaluate/evaluate?a=1`)
                    // this.$router.push({ path: `/member/v3/ievaluate/evaluate`})
                    return;
                }


                this.arrbtn = this.$userHouse.state.usreAppHouserList.btn; // 用户切换
                this.arrbtn.forEach((item) => {
                    // 统一图标点亮
                    // item.isdata = item.type_id == 0 || item.type_id == "" ? false : true;
                    //v2
                    this.arrUnfoldMenu.forEach((item2) => {
                        if (item2.type_key == item.type_key) {
                            item2.num = Number(item.type_num || 0);
                            item2.id = item.type_id;
                            item2.light = item.type_id == 0 || item.type_id == "" ? false : true;
                        }
                    })
                });
                console.log(this.arrUnfoldMenu,'this.arrUnfoldMenu')
                this.arrMessage = this.$userHouse.state.usreAppHouserList.message; // 我的消息
                this.arrImg = this.$userHouse.state.usreAppHouserList.topic; // 业主口碑
                this.objState = this.$userHouse.state.usreAppHouserList.contract.new_status; // 合同状态
                let cityId = this.$userHouse.state.usreAppHouserList.account.city_id; // 合同状态
                if (this.objState == 1 || this.objState == 0) {
                    wxGetLocationH5().then((addresInfo) => {
                        this.getProjectList(
                            addresInfo.latitude,
                            addresInfo.longitude,
                            cityId
                        );
                    });
                }
                this.imgUrl = this.$store.state.banner.index; // 图片
                // 设置合同id
                this.$userHouse.state.usreAppHouserList.btn_cur.forEach((item) => {
                    if (item.type_key == "contract") {
                        this.nContractId = item.type_id;
                    }
                });
                if (this.isShowShare && (this.objState > 1)) {
                    this.getDataShowShare()
                } else if (!this.isShowShare && (this.objState > 1)) {
                    this.getData()
                } else {
                    this.$store.commit("loadSkeleton", {bool: false}); // 页面loading开启
                }
                if (this.$route.query.shareId) {
                    let shareData = {
                        project_uuid: this.$storage.getStorage('project_uuid') || '',
                        id: this.$route.query.shareId,
                    }
                    getReportShare(shareData)
                }
                this.getMokanFun()
            }).catch(err => {
                // if (err.data.error == 1) {
                //     this.objState = 0;
                // }
                this.objState = 0;
            })
        },
        /**
         * 获取分享标识
         * @return {{value: string, key: string}}
         */
        getShareLabel() {
            const url = new URL(location.href);
            // 约定的出口类型 search_key;
            const key = this.$store.state.shareOutKey;
            return {key, value: url.searchParams.get(key)}
        },
        // 项目案例列表
        async getProjectList(lat, lng, id) {
            let _that = this;
            const requestData = {
                page: 0,
                row: 4,
                longitude: lng,
                latitude: lat,
                cityId: id,
            };
            const resultData = await getProjectList(requestData);
            _that.arrCaseList = resultData.data.data.result.lists;
        },
        myProject() {
            this.isUpdata = true;
            // 跳转到我的项目
            // if(!this.objProject.new_address) return this.$toast('暂无项目');
            this.$router.push({
                path: "/member/v3/project/lists",
                query: {
                    appmob: this.$route.query.appmob
                }
            });
        },
        // 查看报告详情
        toReportDetail(item){
            const {project} =  this.$userHouse.state.usreAppHouserList;
            let objData = this.$route.query;
            let data = {
                id: item.rule_report_id,
                projectmgnid: project.new_srv_projectmgnid || this.$storage.getStorage('project_uuid'),
                completed: item.is_completed,
                remove:objData.remove || 0,
                appmob:objData.appmob,
            }
            this.$router.push({
                path:'/member/v3/process/detail',
                query: data
            })
        },
        // 跳转施工标准
        toStandard(){
            let objData = this.$route.query;
            let data = {
                sampleroom: objData.sampleroom || '',
                accountid: objData.accountid || '',
                contractid: objData.contractid || '',
                systemuserid: objData.systemuserid || ''
            }
            window.location.href = `${window.location.origin}/member/appv3/standard/index?sampleroom=${data.sampleroom}&accountid=${data.accountid}&contractid=${data.contractid}&systemuserid=${data.systemuserid}`
        },
        myNews() {
            // 我的消息
            // 公众号通知
            clearAppPost({ mobile: this.$userHouse.state.usreAppHouserList.account.new_telephone2, user_id: this.$userHouse.state.usreAppHouserList.user_id })
            // if (true) return this.$toast("功能未完善");
            this.$router.push({
                path: "/member/v3/mynews/index",
                query: {
                    project_id: this.objProject.new_srv_projectmgnid,
                    appmob: this.$route.query.appmob
                }
            });
        },
        // 获取当前合同信息
        getMemorandum(changeId) {
            let objDataQuery = this.$route.query;
            getMemorandumInfo({
                id:objDataQuery.contractid || this.$userHouse.state.usreAppHouserList.contract.new_contractid,
                change_id: changeId,
                app: 1,
                type: (changeId && changeId!=undefined &&  changeId!='undefined') ? 2 : 1,
                mobile: objDataQuery.appmob || this.$storage.getStorage('app_mob'), // app = 1时必须传手机号，就不用传userid了
            }).then((res) => {
                if(res.data.data.result.main_machine && res.data.data.result.main_machine.list){
                    this.arrImgContracyid = res.data.data.result.main_machine.list
                }
                console.log(res,'合同信息')
            })
        },
        getMeberLists(projectmgnid) {
            let _that = this;
            memberlistV2({
                app:1,
                user_id: this.$storage.getStorage('app_user_id') || this.$store.state.app_user_id,
                projectmgnid: _that.$route.query.projectmgnid || _that.$route.query.project_uuid || projectmgnid ||  _that.$storage.getStorage('project_uuid'),
            })
                .then((res) => {
                    // 当前报告列表
                    console.log(res,'当前报告列表')
                    _that.arrProjectList=res.data.data.result.report
                });
        },
        meunClick(index) {
            // 点击meun
            let item = this.arrUnfoldMenu[index];
            if (!item.light) return;
            const {contract, project} = this.$userHouse.state.usreAppHouserList;
            console.log(item.type_key);
            switch (item.type_key) {
                case 'mapping': //勘察报告
                    this.$router.push({
                        path: `/member/v2/project/mapping`,
                        query: {
                            contract_id: this.$userHouse.state.userInfor.default_contact || "",
                            id: item.id,
                            appmob: this.$route.query.appmob
                        }
                    });
                    break;
                case 'plan': //项目方案书
                    this.$router.push({
                        path: "/member/v3/project/plan",
                        query: {
                            reportId: item.id,
                            remove: this.$route.query.remove || 0,
                            appmob: this.$route.query.appmob
                        },
                    });
                    break;
                case 'third_img': //3D设计方案
                    // window.location.href = item.id;
                    this.$router.push({
                        path: "/member/v3/programme/index",
                        query: {
                            appmob: this.$route.query.appmob
                        }
                    });
                    break;
                case 'contract_draft': //合同备忘
                    // if (this.contractLog.length > 0) {
                    //     this.$router.push({
                    //         path: "/member/v3/contract/survey",
                    //         query: {
                    //             contractId: this.nContractId,
                    //             changeId: this.contractLog[0].change_id,
                    //             appmob: this.$route.query.appmob
                    //         },
                    //     });
                    // } else {
                        this.$router.push({
                            path: "/member/v3/contract/survey",
                            query: {contractId: this.nContractId, remove: this.$route.query.remove || 0, appmob: this.$route.query.appmob},
                        });
                    // }
                    break;
                /*case 5:
                    this.$router.push({path: "/user/house/prospect"});
                    break;*/
                case 'project_group': //项目团队
                    console.log(this.$userHouse.state.usreAppHouserList)
                    this.$router.push({
                        path: "/member/v3/team/index",
                        query: {project: this.$userHouse.state.usreAppHouserList.project.new_srv_projectmgnid, appmob: this.$route.query.appmob}
                    });
                    break;
                /*case 7: //我要推荐
                    this.$router.push({path: "/user/house/recommend"});
                    break;*/
                case 'score': //竣工验收
                    // 需要给竣工评价页面传三个参数
                    //processName项目名称
                    //contract_id合同id
                    //topic_id 项目id
                    // window.location.href = `${window.location.origin}/user/house/finish?company_id=${project.new_id}&project_uuid=${project.new_srv_projectmgnid}&contract_id=${contract.new_contractid}&processName=${project.new_name}`;
                    // window.location.href = `${window.location.origin}/member/v3/evaluate/finish?sharePersonId=${this.$route.query.sharePersonId || 0}&company_id=${project.new_id}&project_uuid=${project.new_srv_projectmgnid}&contract_id=${contract.new_contractid}&remove=${this.$route.query.remove || 0}`;
                    this.$router.push({
                        path: "/member/v3/evaluate/finish",
                        query: {
                            sharePersonId:this.$route.query.sharePersonId || 0,
                            company_id: project.new_id,
                            project_uuid: project.new_srv_projectmgnid,
                            contract_id: contract.new_contractid,
                            remove:this.$route.query.remove || 0,
                            appmob: this.$route.query.appmob
                        },
                    });
                    break;
                /*case 10: //承诺书cover
                    let objcover = this.arrbtn.find((it) => {
                        return it.isdata && it.type_key == "cover";
                    });
                    if (!objcover) return;
                    this.$router.push({path: "/member/covernote/index"});
                    break;*/
                case 'process_detail': //施工报告
                    // window.location.href = `${window.location.origin}/member/process/index?projectmgnid=${project.new_srv_projectmgnid}`;
                    this.$router.push({
                        path: "/member/v3/process/index",
                        query: {
                            projectmgnid: project.new_srv_projectmgnid,
                            remove: this.$route.query.remove || 0,
                            sharePersonId: this.$route.query.sharePersonId || 0,
                            appmob: this.$route.query.appmob
                        },
                    });
                    // /member/process/index
                    break;
                case 'contact':
                    //我要评价
                    // window.location.href = `${window.location.origin}/member/v3/ievaluate/evaluate?sharePersonId=${this.$route.query.sharePersonId || 0}&is_build_completed=${project.is_build_completed}&is_completed=${project.is_completed}&remove=${this.$route.query.remove || 0}`
                    this.$router.push({
                        path: "/member/v3/ievaluate/evaluate",
                        query: {
                            sharePersonId:this.$route.query.sharePersonId || 0,
                            is_build_completed: project.is_build_completed,
                            is_completed: project.is_completed,
                            remove: this.$route.query.remove || 0,
                            appmob: this.$route.query.appmob
                        },
                    });
                    this.$storage.setStorage('objProjectEva', JSON.stringify({
                        company_id: project.new_id,
                        project_uuid: project.new_srv_projectmgnid,
                        contract_id: contract.new_contractid,
                    }));
                    //总裁直通车
                    // window.location.href = 'https://smith.udesk.cn/im_client/?web_plugin_id=170594&group_id=281404';
                    break;
                default:
                    break;
            }
        },
        /* 以下为v2新增方法*/
        getUserInfo() {
            getUser().then((res) => {
                console.log('getUser', res.data.data.result);
                let data = res.data.data.result;
                this.userInfo = {
                    headimgurl: data.headimgurl,
                };
            });
        },
        //获取数据
        getData() {
            Promise.all([
                getProjectLog({
                    project_id: this.objProject.new_srv_projectmgnid,
                    user_id: this.$userHouse.state.usreAppHouserList.user_id,
                }),
                getTeamV2({
                    app: 1,
                    projectmgnid: this.objProject.new_srv_projectmgnid,
                    user_id: this.$userHouse.state.usreAppHouserList.user_id,
                }),
                getProectList({
                    app: 1,
                    user_id: this.$userHouse.state.usreAppHouserList.user_id,
                }),
                getList({
                    app: 1,
                    user_id: this.$userHouse.state.usreAppHouserList.user_id,
                    project_uuid: this.objProject.new_srv_projectmgnid,
                    type: 1,
                })
            ]).then((res) => {
                console.log(res)
                //日志信息
                let objLog = res[0].data.data.result;
                console.log('getProjectLog', objLog)
                this.designLog = objLog.design;
                this.contractLog = objLog.contract;
                this.workLog = objLog.work;
                //项目团队信息
                this.objThemInfo = res[1].data.data.result;
                //获取项目数量
                this.nProject = res[2].data.data.result.total;
                //是否评论过
                this.is_evaluate = res[3].data.data.result.is_completed;
                this.touchMenu(0);
                this.showPopup()
                console.log('关闭load')
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            }).catch(error => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                // this.$router.push({
                //     path: `/ant/error`,
                // })
            })
        },
        getDataShowShare() {
            Promise.all([
                getProjectLog({
                    project_id: this.objProject.new_srv_projectmgnid,
                    user_id: this.$userHouse.state.usreAppHouserList.user_id,
                }),
                getTeamV2({
                    app: 1,
                    projectmgnid: this.objProject.new_srv_projectmgnid,
                    user_id: this.$userHouse.state.usreAppHouserList.user_id,
                }),
                getList({
                    app: 1,
                    user_id: this.$userHouse.state.usreAppHouserList.user_id,
                    project_uuid: this.objProject.new_srv_projectmgnid,
                    type: 1,
                })
            ]).then((res) => {
                console.log(res)
                //日志信息
                let objLog = res[0].data.data.result;
                console.log('getProjectLog', objLog)
                this.designLog = objLog.design;
                this.contractLog = objLog.contract;
                this.workLog = objLog.work;
                //项目团队信息
                this.objThemInfo = res[1].data.data.result;
                //是否评论过
                this.is_evaluate = res[2].data.data.result.is_completed;
                this.touchMenu(0);
                this.showPopup()
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭

                //设置分享
                setTimeout(() => {
                    this.$refs.myShare.setShare();
                }, 200)
            })
        },
        /*getDataList() {
            // 列表接口数据
            let that = this;
            Promise.all([
                that.$userHouse.dispatch("getProecj", that.paramse),
            ]).then((res) => {
                const {total} = that.$userHouse.state.userProList;
                that.nProject = total;
                console.log('关闭load')
                this.$store.commit("loadSkeleton", {bool: false, type: "home",}); // 页面loading关闭
            });
        },*/
        goSchedule() {
            this.$router.push({
                path: "/member/v3/schedule/index",
                query: {appmob: this.$route.query.appmob}
            });
        },
        touchUnfold() {
            this.isUnfoldMenu = !this.isUnfoldMenu;
        },
        touchMenu(index) {
            if(index>=2){
                this.$toast('敬请期待')
                return
            }
            this.nScheduleMennuIndex = index;
            this.showLog = {
                title: '',
                list: [],
            }
            console.log(this.objThemInfo)
            switch (index) {
                case 0:
                    // this.objMainShow = this.objThemInfo.designer;
                    // this.showLog = {
                    //     title: '设计方案',
                    //     list: this.designLog
                    // };
                    this.arrScheduleAllInfo=[]
                    this.arrScheduleAllInfo.push({
                        title: '项目施工',
                        type:'process_detail',
                        list: this.workLog,
                        team:this.objThemInfo.manager
                    })
                    this.arrScheduleAllInfo.push({
                        title: '设计方案',
                        type:'third_img',
                        list: this.designLog,
                        team:this.objThemInfo.designer
                    })
                    this.arrScheduleAllInfo.push({
                        title: '合同',
                        type:'contract_draft',
                        list: this.contractLog,
                        team:this.objThemInfo.salesperson
                    })
                    break;

                // case 1:
                //     this.objMainShow = this.objThemInfo.salesperson;
                //     this.showLog = {
                //         title: '签订合同',
                //         list: this.contractLog
                //     };
                //     break;
                // case 2:
                //     this.objMainShow = this.objThemInfo.manager;
                //     this.showLog = {
                //         title: '施工在线',
                //         list: this.workLog
                //     };
                //     break;
                default:
                    this.objMainShow = {}
                    break;
            }
        },
        touchAccept() {
            const {project} = this.$userHouse.state.usreAppHouserList;
            this.$router.push({
                path: `/member/v3/process/index?projectmgnid=${project.new_srv_projectmgnid}&remove=${this.$route.query.remove || 0}&appmob=${this.$route.query.appmob}`
            })
        },
        touchLook(item,it) {
            console.log(item,it)
            switch (item.type) {
                case 'third_img':
                    this.$router.push({
                        path: "/member/v3/programme/index",
                        query: Object.assign(this.objSampleData, {url: it.url})
                    });
                    break;
                case 'contract_draft':
                    this.$router.push({
                        path: "/member/v3/contract/survey",
                        query: Object.assign(this.objSampleData, {
                            contractId: it.contract_id,
                            changeId: it.change_id,
                        }),
                    });

                    break;
                case 'process_detail':
                    const {project} = this.$userHouse.state.userAppProList;
                    let objData = this.$route.query;
                    let data = {
                        sharePersonId:objData.sharePersonId,
                        sampleroom: objData.sampleroom || '',
                        accountid: objData.accountid || '',
                        contractid: objData.contractid || '',
                        systemuserid: objData.systemuserid || '',
                        id: it.process,
                        projectmgnid: project.new_srv_projectmgnid,
                        completed: 0,
                        remove:objData.remove || 0,
                        appmob:objData.appmob,
                    }
                    this.$router.push({
                        path: '/member/v3/process/detail',
                        query: data
                    })
                    break;
            }
            // switch (item.type) {
            //     case 0:
            //         this.$router.push({
            //             path: "/member/v3/programme/index",
            //             query: {url: item.url, remove: this.$route.query.remove || 0,appmob: this.$route.query.appmob},
            //         });
            //         break;
            //     case 1:
            //         this.$router.push({
            //             path: "/member/v3/contract/survey",
            //             query: {
            //                 contractId: item.contract_id,
            //                 changeId: item.change_id,
            //                 remove: this.$route.query.remove || 0,
            //                 appmob: this.$route.query.appmob
            //             },
            //         });
            //         break;
            //     case 2:
            //         const {project} = this.$userHouse.state.usreAppHouserList;
            //         this.$router.push(`/member/v3/process/detail?id=${item.process}&projectmgnid=${project.new_srv_projectmgnid}&completed=0&remove=${this.$route.query.remove || 0}&appmob=${this.$route.query.appmob}`)
            //         break;
            // }
        },
        showQrcodePopup(name, url) {
            console.log(name, url)
            this.isQrcodePopup = !this.isQrcodePopup
            if (this.isQrcodePopup) {
                this.sQrcodeName = name;
                this.sQcCodeImg = url;
            } else {
                this.sQcCodeImg = '';
                this.sQrcodeName = '';
            }
        },
        showLookpopup() {
            this.isLookPopup = !this.isLookPopup;
        },
        handleTime(time) {
            let arr = time.split(' ')
            return arr[0].slice(0, 4) + '年' + arr[0].slice(5, 7) + '月' + arr[0].slice(8) + '日 ' + arr[1]
            // return arr[0].slice(5, 7) + '月' + arr[0].slice(8) + '日 ' + arr[1]
        },
        touchLookImg(imgs, index) {
            let arrImg = imgs.map((e) => {
                return e.new_filepath
            })
            ImagePreview({
                images: arrImg,
                startPosition: index
            })
        },
        showPopup() {
            if (!this.$userHouse.getters.getPopupSate) {
                if (this.arrUnfoldMenu[4].light) {
                    this.$userHouse.commit('setPopupState', true)
                    const {project} = this.$userHouse.state.usreAppHouserList;
                    /* 施工完成、竣工完成*/
                    if (this.objProject.is_build_completed == '1' && this.objProject.is_completed == '1' && this.is_evaluate == 0) {
                        this.lookPopup = {
                            type: 0,
                            msg: '冷暖风水系统施工已全部完工<br/>并验收完毕<br/>还请您进行最终竣工验收',
                            btnText: '立即验收',
                            url: `/member/v3/process/index?projectmgnid=${project.new_srv_projectmgnid}`,
                        }
                        this.showLookpopup();
                    }
                }
            }
        },
        setLogTimer() {
            this.logTimer = setInterval(() => {
                if (this.$userHouse.state.usreAppHouserList && this.$userHouse.state.usreAppHouserList.project) {
                    this.createLogFun('LIVE')
                }
            }, 10 * 1000)
        },
        clearLogTimer() {
            if (this.logTimer != null) {
                clearInterval(this.logTimer);
                this.logTimer = null;
            }
        },
        createLogFun(type = '') {
            if (type == 'PV') {
                this.log_request_uuid = ''
            }
            if (this.nForbid == 0 && this.$userHouse.state.usreAppHouserList && this.$userHouse.state.usreAppHouserList.project) {
                let objProject = this.$userHouse.state.usreAppHouserList.project; // 用户信息
                if (objProject.new_srv_projectmgnid) {
                    let log_request_uuid = `uuid_${new Date().getTime()}_${getRandomString(4)}`;
                    let data = {
                        path: '/member/v3/index/index',
                        project_id: objProject.new_srv_projectmgnid,
                        rule_id: 0,
                        project_name: objProject.new_name,
                        from: 'APP',
                        request_uuid: log_request_uuid,
                        last_request_uuid: type == 'LIVE' ? this.log_request_uuid : '',
                        type: type,
                        session_uuid: '',
                        is_qiye: 0,
                        share_id: this.$route.query.sharePersonId || 0,
                        user_id: this.$userHouse.state.usreAppHouserList.user_id || this.$storage.getStorage('app_user_id'),
                        app: 1
                    }
                    console.log(this.$userHouse.state.usreAppHouserList.user_id || this.$storage.getStorage('app_user_id'), 'this.$userHouse.state.usreAppHouserList.user_id || this.$storage.getStorage(\'app_user_id\')');
                    // localStorage.setItem('sharePersonId',this.$route.query.sharePersonId || 0)
                    oStorage.setStorage('sharePersonId',this.$route.query.sharePersonId || 0)

                    let uuid = sessionStorage.getItem("uuid");
                    if (uuid) {
                        data.session_uuid = uuid;
                    } else {
                        uuid = hex_md5(getRandomString(12));
                        sessionStorage.setItem("uuid", uuid);
                        data.session_uuid = uuid;
                    }

                    let ua = window.navigator.userAgent.toLowerCase();
                    //判断ua和微信浏览器的标识头是否匹配
                    if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) { // 企业微信
                        data.is_qiye = 1
                    }

                    this.log_request_uuid = log_request_uuid;
                    createLog(data)
                }
            }
        }
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/base.scss";
@import "./index";

.nodata {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
}
</style>
